import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectTemplatesMap } from '@debbie/cortex/dist/templates/selectors.js';
import { Modal, Badge } from '../index.js';
import { APIBASE } from '../../config.js';
import THEME from '../../theme.js';
import MailIcon from '../Icons/Mail.js';
import DefaultSummary from './DefaultSummary.js';
import ObjectComp from '../ObjectComp.js';
const LetterSummary = (props) => {
    const [open, setOpen] = useState(false);
    const interaction = props.interaction;
    const letter = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    const template = useSelector((s) => {
        const templatesMap = selectTemplatesMap(s);
        return ((interaction.templateId && templatesMap[interaction.templateId]) || null);
    });
    return (React.createElement(DefaultSummary, { transparrent: !open, ...props },
        React.createElement("div", { style: {
                cursor: 'pointer',
            }, onClick: () => {
                setOpen(!open);
            } },
            template && (React.createElement(React.Fragment, null,
                React.createElement("p", { style: {
                        fontWeight: '900',
                        margin: '0 0 0.8em',
                    } }, template.name),
                !!template.tags?.length && (React.createElement("p", { style: { marginTop: 0 } }, template.tags.map(({ tag }) => (React.createElement(Badge, { style: { marginRight: 5 }, theme: THEME.COLOR_ACCENT }, lang.templateTags[tag]))))))),
            React.createElement(MailIcon, { style: {
                    margin: '0.15em 0 -0.15em 0',
                } }),
            ' ',
            props.interaction.transacted
                ? `${lang.interactions.transacted} ${moment(props.interaction.transacted).format(THEME.DATE_FORMAT_LONG)}`
                : '',
            interaction.events && !!interaction.events.length ? (React.createElement("div", { style: {
                    marginTop: `${THEME.GRID_SPACING}px`,
                    wordBreak: 'break-word',
                } }, interaction.events.map((event) => (React.createElement("div", { key: event.id, style: { display: 'inline-flex', width: 'fit-content' }, "data-tooltip-id": "tooltip-default", "data-tooltip-content": moment(event.createdAt).format(THEME.DATE_FORMAT_LONG) },
                React.createElement(Badge, { theme: THEME.WARNING, style: { marginRight: '5px' } }, 
                // @ts-ignore
                lang.returnLetterReasons[event.type])))))) : null),
        open && (React.createElement(Modal, { header: lang.interactionTypes.LETTER, onToggle: () => {
                setOpen(!open);
            } },
            React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/files/${letter.pdf}/debbie.pdf` })))));
};
export default LetterSummary;
//# sourceMappingURL=LetterSummary.js.map